// src/components/auth/PrivateRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const PrivateRoute = ({ children, requireProfile = false }) => {
  const { currentUser, userProfile, loading } = useAuth();

  // Show loading spinner while checking auth state
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If route requires completed profile, check if profile is completed
  if (requireProfile && (!userProfile || !userProfile.profileCompleted)) {
    return <Navigate to="/profile" replace />;
  }

  // If user has completed profile but trying to access profile page, redirect to dashboard
  if (!requireProfile && userProfile?.profileCompleted && window.location.pathname === '/profile') {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default PrivateRoute;